import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import './Otp.css';

const Otp = () => {
  const otp1 = React.useRef(null);
  const otp2 = React.useRef(null);
  const otp3 = React.useRef(null);
  const otp4 = React.useRef(null);

  const handleSubmit = (e) => {
    e.preventDefault();

    const data = {
      otp1Value: otp1.current.value,
      otp2Value: otp2.current.value,
      otp3Value: otp3.current.value,
      otp4Value: otp4.current.value,
    };
    return data;
  };

  const history = useHistory();
  function goToSetPassword() {
    history.push('/set-password');
  }

  return (
    <section className="otp_section">
      <div className="otp">
        <h2>Reset Password</h2>
        <p>Please enter the OTP sent to your email address thanks.</p>

        <form
          onSubmit={handleSubmit}
          data-group-name="digits"
          data-autosubmit="false"
          autoComplete="off"
          className="otp_form"
        >
          <div className="otp_1">
            <label htmlFor="day">
              <input
                type="text"
                pattern="[0-9]*"
                maxLength="1"
                size="1"
                required="required"
                ref={otp1}
                placeholder="0"
                id="digit-1"
                name="digit-1"
                data-next="digit-2"
              />
            </label>
          </div>

          <div className="otp_2">
            <label htmlFor="otp">
              <input
                type="text"
                pattern="[0-9]*"
                maxLength="1"
                size="1"
                required="required"
                ref={otp2}
                placeholder="0"
                id="digit-2"
                name="digit-2"
                data-next="digit-3"
                data-previous="digit-1"
              />
            </label>
          </div>

          <div className="otp_3">
            <label htmlFor="otp">
              <input
                type="text"
                pattern="[0-9]*"
                maxLength="1"
                size="1"
                required="required"
                placeholder="0"
                ref={otp3}
                id="digit-3"
                name="digit-3"
                data-next="digit-4"
                data-previous="digit-2"
              />
            </label>
          </div>

          <div className="otp_4">
            <label htmlFor="otp">
              <input
                type="text"
                pattern="[0-9]*"
                maxLength="1"
                size="1"
                required="required"
                placeholder="0"
                ref={otp4}
                id="digit-4"
                name="digit-4"
                data-next="digit-5"
                data-previous="digit-3"
              />
            </label>
          </div>

          <input
            type="submit"
            value="Continue"
            className="btn"
            onClick={goToSetPassword}
          />

          <p className="otp-footer">
            Didn’t recieve Mail?{' '}
            <Link to="/" className="otp_link">
              Resend Code
            </Link>
          </p>
        </form>
      </div>
    </section>
  );
};

export default Otp;
